import { create, type StateCreator } from 'zustand';
import { shouldReceiveNotiSafeLocalStorage } from '../lib/storage/storageImplementations';

type ReceiveNoti = ReturnType<typeof getState>;

interface MuteState {
  shouldReceiveNoti: ReceiveNoti;
  setShouldReceiveNoti: (val: boolean) => void;
}

const getState = (): 'Y' | 'N' | null => {
  if (typeof window === 'undefined') return null;
  const shouldReceiveNoti = shouldReceiveNotiSafeLocalStorage.get();
  if (shouldReceiveNoti?.includes('Y')) return 'Y';
  if (shouldReceiveNoti?.includes('N')) return 'N';
  return null;
};

const setState = (val: boolean) => {
  if (typeof window === 'undefined') return;
  const shouldReceiveNoti = val ? 'Y' : 'N';
  shouldReceiveNotiSafeLocalStorage.set(shouldReceiveNoti);
  return shouldReceiveNoti;
};

const store: StateCreator<MuteState, [], [], MuteState> = (set) => ({
  shouldReceiveNoti: getState(),
  setShouldReceiveNoti: (val: boolean) => {
    const state = setState(val);
    set({ shouldReceiveNoti: state });
  },
});

const useShouldReceiveNotification = create<MuteState>()(store);

export default useShouldReceiveNotification;
